import { SubscriptionStatus } from '../../../services/administration/subscription-status.ts';

const statuses: { [key in SubscriptionStatus]: string } = {
  active: 'Actief',
  cancelled: 'Beëindigd',
  created: 'Aangemaakt',
  upcoming: 'Aankomend',
};

export const SubscriptionMessages = {
  title: 'Abonnement',
  description:
    'Dit overzicht toont alle jullie abonnementen. ' +
    'Je kunt hier de status van je abonnementen bekijken. ' +
    'Ga naar de postcode check pagina om een nieuw abonnement af te sluiten.',
  display: 'Abonnement {label}',
  none: 'Er is nog geen abonnement aangemaakt.',
  renew: 'Verleng abonnement {order_number} - {connection_address}',
  search: 'Zoek op adres, ordernummer, beschrijvingen en abonnement regel IDs',
  upgrade: 'Upgrade van abonnement {order_number} - {connection_address}',
  visit: 'Ga naar abonnement',

  hint: {
    ppu: 'De prijs na toepassing van (staffel)kortingen en indexaties. Dit kan afwijken van de prijs in de order.',
  },
  properties: {
    amount: 'Aantal',
    description: 'Omschrijving',
    dateEnd: 'Einddatum',
    dateStart: 'Startdatum',
    id: 'ID',
    initialPeriod: 'Contracttermijn (maanden)',
    nextInvoiceDate: 'Volgende factuurdatum',
    orderNumber: 'Ordernummer',
    ppu: 'Nettoprijs per eenheid',
    recurrence: 'Facturatieperiode',
  },
  lineItems: 'Abonnementsregels',
  recurrence: 'Per {months} maand',
  statuses,
};
